import { useMutation, useQueryClient } from "@tanstack/react-query";
import newArtistsClient, {
  NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
  ReviewNewArtistInput,
} from "../../../api/new-artists";
import { extractApiErrorMessage } from "../../../utils/util";

interface UseReviewNewArtistMutationOptions {
  onSuccess?: () => void;
}

export const getReviewErrorMessage = (error: unknown): string =>
  extractApiErrorMessage(error, "Failed to submit review. Please try again.");

const useReviewNewArtistMutation = (
  options?: UseReviewNewArtistMutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["review-new-artist"],
    mutationFn: (input: ReviewNewArtistInput) =>
      newArtistsClient.reviewSubmission(input),
    onSuccess: () => {
      options?.onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
      });
    },
  });
};

export default useReviewNewArtistMutation;
